import api from "./api";

export default class CommonApi {
  static async fileDownload(data) {
    return await api.post(`file/download`, data);
  }

static async postSmstCdListForExternal(data) {
  return await api.postExternal(`/loginpass/getCommCodeList.do`, data);
}
}
